export function deepSortObj(obj) {
    if (typeof obj !== 'object' || !obj) {
        return obj;
    }
    if (Array.isArray(obj)) {
        return obj.map((i) => deepSortObj(i));
    }
    return Object.keys(obj)
        .sort()
        .reduce((sortedObject, key) => {
        sortedObject[key] = deepSortObj(obj[key]);
        return sortedObject;
    }, {});
}
//# sourceMappingURL=obj-sort.js.map